/**
 * @file This is a timeline component
 * @author Heino Lenting, Willem Jan Weitering
 */
import { OnInit } from '@angular/core';
import { TimelineService } from '../timeline.service';
import { FileReaderService } from '../../base/file-reader.service';
import { AlertsService } from '../../core/alerts.service';
/**
 * Class for the timeline functionality
 */
var TimelineComponent = /** @class */ (function () {
    /**
     * Constructs a TimelineComponent
     * @param timelineService The timelineService
     */
    function TimelineComponent(timelineService, fileReaderService, alertsService) {
        this.timelineService = timelineService;
        this.fileReaderService = fileReaderService;
        this.alertsService = alertsService;
        // REMOVE: (temporarily for faking config)
        this.configuration = {
            instruction: 'instructions/standaard/timeline/timeline'
        };
        /* Page size of the list */
        this.pageSize = 5;
        /* Current page used for pagination (previous pages are also visible) */
        this.currentPage = 1;
    }
    Object.defineProperty(TimelineComponent.prototype, "timelineItems", {
        /** Gets the items w.r.t. currentPage and pageSize */
        get: function () {
            return this.timelineService.getTimelineItems(0, this.currentPage * this.pageSize);
        },
        enumerable: true,
        configurable: true
    });
    /** Checks if there are more items available */
    TimelineComponent.prototype.hasMore = function () {
        return Math.ceil(this.timelineService.totalItems / this.pageSize) > this.currentPage;
    };
    /** Show also the next page of timeline items*/
    TimelineComponent.prototype.showMore = function () {
        if (this.hasMore()) {
            this.currentPage++;
        }
    };
    TimelineComponent.prototype.ngOnInit = function () { };
    return TimelineComponent;
}());
export { TimelineComponent };
